import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconAccess = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={34}
    height={34}
    fill="none"
    viewBox="0 0 34 34"
    aria-hidden="true"
    {...props}
  >
    <g filter="url(#icon-access_svg__a)">
      <path
        fill="url(#icon-access_svg__b)"
        d="M13.29 14.625h1.523c.078 1.055.273 2.031.546 2.773a3.736 3.736 0 0 1-2.07-2.773Zm0-1.25c.194-1.21 1.015-2.227 2.07-2.734-.274.742-.47 1.68-.547 2.734h-1.524ZM17 17.711c-.313-.273-.82-1.328-.938-3.086h1.836c-.117 1.758-.625 2.813-.898 3.086Zm1.602-7.07c1.054.507 1.875 1.523 2.07 2.734h-1.524c-.078-1.055-.273-1.992-.546-2.734ZM23.25 6.5c1.367 0 2.5 1.133 2.5 2.5v15c0 1.406-1.133 2.5-2.5 2.5h-12.5a2.468 2.468 0 0 1-2.5-2.5V9c0-1.367 1.094-2.5 2.5-2.5h12.5Zm-1.875 16.25a.642.642 0 0 0 .625-.625c0-.313-.313-.625-.625-.625h-8.75a.642.642 0 0 0-.625.625c0 .352.273.625.625.625h8.75ZM17 19c2.734 0 5-2.227 5-5 0-2.734-2.266-5-5-5-2.773 0-5 2.266-5 5 0 2.773 2.227 5 5 5Zm1.602-1.602c.273-.742.468-1.718.546-2.734h1.524c-.195 1.211-1.016 2.227-2.07 2.734Zm-2.54-4.023c.118-1.719.625-2.773.938-3.047.273.274.781 1.328.898 3.047h-1.835Z"
      />
    </g>
    <defs>
      <linearGradient
        id="icon-access_svg__b"
        x1={27}
        x2={8.025}
        y1={7}
        y2={26.974}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={0.18} stopColor="#EEE" />
        <stop offset={0.73} stopColor="#A0A0A0" />
        <stop offset={1} stopColor="#979797" />
      </linearGradient>
      <filter
        id="icon-access_svg__a"
        width={36}
        height={36}
        x={-1}
        y={0.5}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6025_5315"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_6025_5315"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_6025_5315"
          result="effect2_dropShadow_6025_5315"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_6025_5315"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
));
export default SvgIconAccess;
